import * as type from './mutation-types'
import * as API from './api'
import { ajax } from '@/utils/fetch'

// 用户信息
export const getUserInfo = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETUSERINFO_REQUEST, data)
        // http 请求
    return ajax.post(
        API.getUserInfo, {
            commit
        },
        data,
        type.GETUSERINFO_RECEIVE
    )
};
// 服务器列表信息
export const getServerList = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETSERVERLIST_REQUEST, data)
        // http 请求
    return ajax.get(
        API.getServerList, {
            commit
        },
        data,
        type.GETSERVERLIST_RECEIVE
    )
};
// 游戏角色信息
export const getGameRoleList = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETGAMEROLELIST_REQUEST, data)
        // http 请求
    return ajax.get(
        API.getGameRoleList, {
            commit
        },
        data,
        type.GETGAMEROLELIST_RECEIVE
    )
};
// 游戏大区信息
export const getAreaList = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETAREALIST_REQUEST, data)
        // http 请求
    return ajax.get(
        API.getAreaList, {
            commit
        },
        data,
        type.GETAREALIST_RECEIVE
    )
};
// 积分商城开关
export const getSwitchInfo = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETSWITCHINFO_REQUEST, data)
        // http 请求
    return ajax.get(
        API.getSwitchInfo, {
            commit
        },
        data,
        type.GETSWITCHINFO_RECEIVE
    )
}